<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <h1>Task reporting</h1>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="4">
        <v-menu
          ref="menu1"
          v-model="menu1"
          offset-y
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startDate"
              readonly
              v-bind="attrs"
              v-on="on"
              label="Start Date"
              prepend-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker v-model="startDate"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="4">
        <v-menu
          ref="menu2"
          v-model="menu2"
          offset-y
          max-width="290px"
          min-width="290px"
          :close-on-content-click="false"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endDate"
              readonly
              v-bind="attrs"
              v-on="on"
              label="End Date"
              prepend-icon="mdi-calendar"
            ></v-text-field>
          </template>
          <v-date-picker v-model="endDate"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="4">
        <v-autocomplete
          v-if="staff"
          v-model="filters.assignedTo"
          class="ml-2 pt-1"
          item-text="name"
          item-value="id"
          label="Assigned to"
          clearable
          dense
          filled
          outlined
          small-chips
          solo
          rounded
          multiple
          :items="staff"
        >
          <template v-slot:selection="data">
            <v-chip v-bind="data.attrs" :input-value="data.selected">
              <v-avatar left>
                <v-img :src="data.item.avatar"></v-img>
              </v-avatar>
              {{ data.item.name }}
            </v-chip>
          </template>
          <template v-slot:item="data">
            <v-list-item-avatar>
              <img :src="data.item.avatar" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.name"></v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div v-if="resolutionReport">

          <h4 class="text-center my-5">Category Breakdown</h4>
          <v-simple-table v-if="resolutionReport.by_type">
            <thead>
              <tr>
                <th>Task Type</th>
                <th>Total</th>
                <th>Unresolved</th>
                <th>Resolved (Same Day)</th>
                <th>Resolved (Within 7 Days)</th>
                <th>Resolved (After 7 Days)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="type in Object.keys(resolutionReport.by_type)" :key="type">
                <td>{{ type }}</td>
                <td>{{ resolutionReport.by_type[type].total }}</td>
                <td>{{ resolutionReport.by_type[type].unresolved }}
                  ({{ getPercent(resolutionReport.by_type[type].total, resolutionReport.by_type[type].unresolved) }}%)
                </td>
                <td>{{ resolutionReport.by_type[type].resolved_same_day }}
                  ({{ getPercent(resolutionReport.by_type[type].total, resolutionReport.by_type[type].resolved_same_day) }}%)
                </td>
                <td>{{ resolutionReport.by_type[type].resolved_within_7_days }}
                  ({{ getPercent(resolutionReport.by_type[type].total, resolutionReport.by_type[type].resolved_within_7_days) }}%)
                </td>
                <td>{{ resolutionReport.by_type[type].resolved_after_7_days }}
                  ({{ getPercent(resolutionReport.by_type[type].total, resolutionReport.by_type[type].resolved_after_7_days) }}%)
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <h4 class="text-center my-5">Task Breakdown</h4>
          <vue-json-to-csv :json-data="byTaskData" csv-title="Task List Export">
            <v-btn x-small>
              Export
            </v-btn>
          </vue-json-to-csv>
          <v-data-table
            :headers="taskListHeaders"
            :items="byTaskData"
            :items-per-page="100"
            :search="search"
            show-group-by
            sort-by="total"
            :sort-desc="true"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Search"
                class="mx-4"
              />
            </template>
            <template #item.unresolved ="{ item }">
              {{ item.unresolved }} ({{getPercent(item.total, item.unresolved)}}%)
            </template>
            <template #item.resolved_same_day ="{ item }">
              {{ item.resolved_same_day }} ({{getPercent(item.total, item.resolved_same_day)}}%)
            </template>
            <template #item.resolved_within_7_days ="{ item }">
              {{ item.resolved_within_7_days }} ({{getPercent(item.total, item.resolved_within_7_days)}}%)
            </template>
            <template #item.resolved_after_7_days ="{ item }">
              {{ item.resolved_after_7_days }} ({{getPercent(item.total, item.resolved_after_7_days)}}%)
            </template>
          </v-data-table>
          <highcharts :options="resolutionChart"></highcharts>
          <highcharts :options="resolutionPieChart"></highcharts>
          <h4 class="text-center my-5">Task List</h4>
          <vue-json-to-csv :json-data="resolutionReport.task_list" csv-title="Task Export">
            <v-btn x-small>
              Export
            </v-btn>
          </vue-json-to-csv>
          <v-data-table
            :headers="taskHeaders"
            :items="resolutionReport.task_list"
            :items-per-page="100"
            :search="search"
            show-group-by
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Search"
                class="mx-4"
              />
            </template>
          </v-data-table>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { RESOLUTION_REPORT } from "@/constants/graphql/reporting/tasks";
import {STAFF_QUERY} from "@/graphql/queries/user";
import {decodeId} from "@/lib/string";
import {getUserName} from "@/lib/username";
import VueJsonToCsv from "vue-json-to-csv";

export default {
  name: "TaskReporting",
  components: {
    VueJsonToCsv
  },
  data() {
    return {
      search: '',
      startDate: null,
      endDate: null,
      menu1: false,
      menu2: false,
      staff: [],
      resolutionReport: null,
      filters: {
        assignedTo: []
      },
      taskListHeaders: [
        {
          text: 'Title',
          align: 'start',
          sortable: true,
          value: 'title'
        },
        {
          text: 'Total',
          sortable: true,
          value: 'total'
        },
        {
          text: 'Unresolved',
          sortable: true,
          value: 'unresolved'
        },
        {
          text: 'Resolved (Same Day)',
          sortable: true,
          value: 'resolved_same_day'
        },
        {
          text: 'Resolved (Within 7 Days)',
          sortable: true,
          value: 'resolved_within_7_days'
        },
        {
          text: 'Resolved (After 7 Days)',
          sortable: true,
          value: 'resolved_after_7_days'
        },
      ],
      taskHeaders: [
        {
          text: 'Date',
          align: 'start',
          sortable: true,
          value: 'date'
        },
        {
          text: 'Task Type',
          groupable: true,
          sortable: true,
          filterable: true,
          value: 'task_type'
        },
        {
          text: 'Title',
          groupable: true,
          sortable: true,
          filterable: true,
          value: 'title'
        },
        {
          text: 'Resolution Type',
          groupable: true,
          sortable: true,
          filterable: true,
          value: 'resolution_type'
        },
        {
          text: 'Resolved Date',
          groupable: true,
          sortable: true,
          filterable: true,
          value: 'resolved_date'
        },
        {
          text: 'Reporter',
          groupable: true,
          sortable: true,
          filterable: true,
          value: 'reporter'
        },
        {
          text: 'Assigned To',
          groupable: true,
          sortable: true,
          filterable: true,
          value: 'assigned_to'
        },
      ]
    };
  },
  watch: {
    filters: {
      handler(val) {
        this.$apollo.queries.resolutionReport.refetch();
      },
      deep: true
    }
  },
  computed: {
    resolutionChart() {
      let series = []
      series.push({
        data: Object.keys(this.resolutionReport.total).map(element => [element, this.resolutionReport['total'][element]]),
        name: "Total tasks Raised"
      });
      series.push({
        data: Object.keys(this.resolutionReport.unresolved).map(element => [element, this.resolutionReport['unresolved'][element]]),
        name: "Unresolved tasks"
      });
      series.push({
        data: Object.keys(this.resolutionReport.resolved_same_day).map(element => [element, this.resolutionReport['resolved_same_day'][element]]),
        name: "Resolved on same day"
      });
      series.push({
        data: Object.keys(this.resolutionReport.resolved_within_7_days).map(element => [element, this.resolutionReport['resolved_within_7_days'][element]]),
        name: "Resolved within 7 days"
      });
      series.push({
        data: Object.keys(this.resolutionReport.resolved_after_7_days).map(element => [element, this.resolutionReport['resolved_after_7_days'][element]]),
        name: "Resolved after 7 days"
      });
      return {
        chart: {
          type: "line",
        },
        credits: {
          enabled: false,
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: "Task Resolution Rate",
        },
        xAxis: {
          categories: Object.keys(this.resolutionReport.total),
        },
        yAxis: {
          title: {
            text: "% engageed",
          },
        },

        series: series,
      };
    },
    resolutionPieChart() {
      return {
        title: {
          text: "Task Resolution Breakdown",
        },
        chart: {
          type: "pie",
        },
        series: [{
          data: [
            {
              name: 'Resolved on same day',
              y: this.totals['resolved_same_day']
            },
            {
              name: 'Resolved within 7 days',
              y: this.totals['resolved_within_7_days']
            },
            {
              name: 'Not resolved',
              y: this.totals['unresolved']
            },
            {
              name: 'Resolved after 7 days',
              y: this.totals['resolved_after_7_days']
            }
          ],
          name:"Total Tasks"
        },
        ]
      }
    },
    totals() {
      let totals = {
        'total': 0,
        'resolved_after_7_days': 0,
        'resolved_same_day': 0,
        'resolved_within_7_days': 0,
        'unresolved': 0
      }
      Object.keys(totals).forEach(key => {
        Object.keys(this.resolutionReport[key]).forEach(element => totals[key] += this.resolutionReport[key][element])
      });
      return totals;
    },
    byTaskData() {
      let data = [];
      Object.keys(this.resolutionReport.by_task).forEach(cat => {
        data.push({
          title: cat,
          resolved_after_7_days: this.resolutionReport.by_task[cat].resolved_after_7_days,
          resolved_same_day: this.resolutionReport.by_task[cat].resolved_same_day,
          resolved_within_7_days: this.resolutionReport.by_task[cat].resolved_within_7_days,
          total: this.resolutionReport.by_task[cat].total,
          unresolved: this.resolutionReport.by_task[cat].unresolved,
        })
      });
      return data;
    }
  },
  methods: {
    getPercent(total, amount) {
      if (amount === 0)
        return 0;
     return Math.round((amount / total)  * 100)
    }
  },
  apollo: {
    users: {
      query: STAFF_QUERY,
      variables() {
        return {
          isActive: true,
          isStaff: true,
        };
      },
      result(response) {
        if (response.data && !response.loading) {
          this.staff = [];

          response.data.users.edges.forEach((item) => {
            let data = {
              id: decodeId(item.node.id),
              name: getUserName(item.node),
              avatar: item.node.userProfile?.profilePicture,
            };

            this.staff.push(data);
          });

          this.staff.sort((a, b) => (a.text > b.text ? 1 : -1));
        }
      },
    },
    resolutionReport: {
      query: RESOLUTION_REPORT,
      fetchPolicy: "network-only",
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          filters: this.filters
        }
      },
      skip() {
        return !this.startDate || !this.endDate
      }
    }
  }
}
</script>
